export const LAYOUT_ADMIN_HOME = `/secure/home`;

export const LAYOUT_AUTH_LOGIN = "/auth/login";
export const LAYOUT_AUTH_FORGET = "/auth/forget";
export const LAYOUT_AUTH_RESET = "/auth/reset";
